export default "__VITE_ASSET__CKOEtlPS__"